import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router";
import ReactPaginate from "react-paginate";
import { vendorService } from "../../Services";
import { ChangeStatus } from "../../Components";
import Loader from "../../Components/Loader";
import { MdEdit } from "react-icons/md";
import { useLocation } from 'react-router-dom'
import CheckAccess from "../../Function/CheckAccess";
let currentPage1 = 1;

export const VendorList = () => {
  const [vendorList, setVendorList] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, limit: 10 });
  const [currentPage, setCurrentPage] = useState(currentPage1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [loader, setLoader] = useState(true);

  const history = useHistory();
  const imgRef = useRef();

  const location = useLocation()
  let user_type = localStorage.getItem("user_type")

  useEffect(() => {
    getVendorList();
    // eslint-disable-next-line
  }, [currentPage]);

  const getVendorList = () => {
    let param = { ...pagination, page: currentPage };
    if (pagination.search) {
      param["search"] = pagination.search;
      param["page"] = 1;
    }
    vendorService.getVendor(param).then((res) => {
      if (res.status) {
        setLoader(false);
        setVendorList(res.data);
        setPagination({ ...pagination, ...res.pagination });
      } else {
        setLoader(false);
      }
    });
  };

  const onModalSubmit = () => {
    let postData = {
      id: isModalOpen._id,
      status: isModalOpen.status === "ACTIVE" ? "INACTIVE" : "ACTIVE",
    };
    vendorService.update_vendor_status(postData).then((res) => {
      if (res.status) {
        setIsModalOpen(false);
        getVendorList();
      }
    });
  };

  const onDeleteSubmit = () => {
    let postData = {
      id: deleteModalOpen._id,
      is_delete: "YES",
    };

    vendorService.deleteVendor(postData).then((res) => {
      if (res.status) {
        setDeleteModalOpen(false);
        getVendorList();
      }
    });
  };

  const onPageChangeEvent = (e) => {
    currentPage1 = e.selected + 1
    setLoader(true);
    setCurrentPage(e.selected + 1);
  };

  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <div className="d-flex justify-content-between mb-3">
              <div className="input-group pl-3 w-25">
                <input
                  className="form-control"
                  type="text"
                  placeholder="search..."
                  onChange={(e) =>
                    setPagination({ ...pagination, search: e.target.value })
                  }
                  onKeyPress={(e) => e.key === "Enter" && getVendorList()}
                  onKeyUp={(e) =>
                    e.key === "Backspace" &&
                    pagination.search.length <= 0 &&
                    getVendorList()
                  }
                ></input>
                <div className="input-group-prepend">
                  <button
                    className="input-group-text pointer search-btn"
                    onClick={() => getVendorList()}
                    style={{ backgroundColor: "#e5e4ec" }}
                  >
                    search
                  </button>
                </div>
              </div>
              {
                (CheckAccess(224,"add") ||  user_type === "SUPERADMIN" )&& 
              <button
                className="btn btn-primary w-sm waves-effect waves-light mx-3"
                onClick={() => history.push("/add-vendor")}
              >
                Add Vendor
              </button>
              }
              <input ref={imgRef} type="file" className="d-none" />
            </div>
            <div className="table-responsive">
              <table className="table table-centered table-nowrap mb-0">
                <thead className="table-light">
                  <tr>
                    <th>S no.</th>
                    <th>Vendor name</th>
                    <th>Vendor Type</th>
                    <th>Contact No.</th>
                    <th>Email</th>
                    <th>Business name</th>
                    <th>Service Type</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {vendorList.length > 0 &&
                    vendorList.map((item, key) => (
                      <tr key={key}>
                        <td className="text-body fw-bold">
                          {(pagination.page - 1) * pagination.limit + (key + 1)}
                        </td>
                        <td>{item.vendor_name.substring(0, 15)}</td>
                        <td>{item.vendor_type}</td>
                        <td>{item.vendor_contact_number}</td>
                        <td>{item.vendor_email}</td>
                        <td>{item.business_name.substring(0, 10)}</td>
                        <td>
                          <span className="badge rounded-pill font-size-12 pointer bg-success">
                            {item.service_type}
                          </span>
                        </td>
                        <td>
                          <span
                            className={
                              "badge rounded-pill font-size-12 pointer" +
                              (item.status === "ACTIVE"
                                ? " bg-success"
                                : " bg-soft-danger")
                            }
                            onClick={() => setIsModalOpen(item)}
                          >
                            {/* {item.status ? item.status : 'NA'} */}
                            {item.status}
                          </span>
                        </td>
                        <td>
                        {
                           (CheckAccess(224,"edit") || user_type === "SUPERADMIN") && 
                          <MdEdit
                            className="pointer"
                            onClick={() =>
                              history.push("/edit-vendor?id=" + item._id, item)
                            }
                            color="#0323fe"
                            size="25px"
                          />
                        }
                          {/* <MdDeleteForever
                                                    className="pointer"
                                                    color="red"
                                                    size="25px"
                                                    onClick={() => setDeleteModalOpen(item)}

                                                /> */}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
              {vendorList.length <= 0 && !loader && (
                <div className="text-center w-100 bg-warning my-5">
                  <h6 className="py-2"> list not available </h6>
                </div>
              )}
            </div>
          </div>
          {vendorList.length > 0 &&
            pagination.totalRecord > pagination.limit && (
              <ReactPaginate
                previousLabel={
                  <img
                    src="assets/images/prev.svg"
                    height={15}
                    alt="not found"
                  />
                }
                forcePage={currentPage - 1}
                nextLabel={
                  <img
                    src="assets/images/next.svg"
                    height={15}
                    alt="not found"
                  />
                }
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={Math.ceil(pagination.totalRecord / pagination.limit)}
                marginPagesDisplayed={2}
                pageRangeDisplayed={3}
                onPageChange={(e) => onPageChangeEvent(e)}
                containerClassName={"pagination"}
                activeClassName={"active"}
              />
            )}
          <Loader isShow={loader} />
        </div>
        {Boolean(isModalOpen) && (
          <ChangeStatus
            isOpen={Boolean(isModalOpen)}
            title="Update Status"
            message={`Are you sure want to ${
              isModalOpen.status === "ACTIVE" ? "Inactive" : "Active"
            } status ?`}
            onSubmitEvent={() => onModalSubmit()}
            handleClose={() => setIsModalOpen(false)}
          />
        )}

        {Boolean(deleteModalOpen) && (
          <ChangeStatus
            isOpen={Boolean(deleteModalOpen)}
            title="Delete"
            message={`Are you sure want to delete?`}
            onSubmitEvent={() => onDeleteSubmit()}
            handleClose={() => setDeleteModalOpen(false)}
          />
        )}
      </div>
    </div>
  );
};
